@if (data) {
  <div class="pot-block-paragraph">
    @if (data.hasQuotesIcons) {
      <pot-icon-svg-quote-open
        [attr.data-aos]="data.aosAnimation?.type"
        [attr.data-aos-offset]="aosAnimationOffset"
        [attr.data-aos-delay]="data.aosAnimation?.delay"
      ></pot-icon-svg-quote-open>
    }
    @for (paragraph of data.paragraphs; track paragraph) {
      <p
        [attr.data-aos]="data.aosAnimation?.type"
        [attr.data-aos-offset]="aosAnimationOffset"
        [attr.data-aos-delay]="data.aosAnimation?.delay"
        [innerHTML]="paragraph"
        [ngClass]="cssClasses"
        [ngStyle]="{ color: data.fontColor }"
      ></p>
    }
    @if (data.hasQuotesIcons) {
      <pot-icon-svg-quote-close
        [attr.data-aos]="data.aosAnimation?.type"
        [attr.data-aos-offset]="aosAnimationOffset"
        [attr.data-aos-delay]="data.aosAnimation?.delay"
      ></pot-icon-svg-quote-close>
    }
  </div>
}
